import createCache, { type EmotionCache } from '@emotion/cache'

// Dedicated cache so MUI's emotion <style> tags are grouped under their own key
// and anchored to a fixed <meta> in <head>. Without this, MUI shares the default
// `css` cache with no insertion anchor; other libs churning <head> (Gatsby Head,
// segment, manifest) can strand a tracked tag, and the next runtime insert throws
// `insertBefore ... not a child of this node` in production (speedy mode only).
const KEY = 'mui'

const createEmotionCache = (): EmotionCache => {
  const insertionPoint =
    typeof document !== 'undefined'
      ? (document.querySelector<HTMLElement>(
          'meta[name="emotion-insertion-point"]',
        ) ?? undefined)
      : undefined
  return createCache({ key: KEY, insertionPoint })
}

let browserCache: EmotionCache | undefined

// One cache per browser session; a fresh cache per SSR render.
export const getEmotionCache = (): EmotionCache => {
  if (typeof document === 'undefined') return createEmotionCache()
  if (!browserCache) browserCache = createEmotionCache()
  return browserCache
}
